import React, {useContext, useLayoutEffect, useState} from 'react';
import {Pressable, Platform} from 'react-native';
import MainStyle from '../../../../../../MainStyle';
import Button from '../../../../../components/Button';
import {StoreContext} from "../../../../../components/StoreContextProvider";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {useNavigation} from "@react-navigation/native";
import ServiceClient from "../../../../../utils/ServiceClient";
import Div from "../../../../../lib/Div";
import VerifyInformationModal from "../ContactInfo/VerifyInformationModal";
import P from "../../../../../lib/P";
import {colors} from "../../../../../assets/styles/colors";

// @ts-ignore
import VeriffSdk from '@veriff/react-native-sdk';
import {isFullSwing, StartingPage} from "../../../../../constants";

let createFrame: any, messages: any;

if (Platform.OS === 'web') {
  const {createVeriffFrame, MESSAGES} = require('@veriff/incontext-sdk');
  createFrame = createVeriffFrame;
  messages = MESSAGES;
}

type Props = { goBack?: () => void, redirectUser: () => void }

const KycTerm = (props: Props) => {
  const Context = useContext(StoreContext);
  const {cancelModalConfig, session} = Context;
  const navigation: any = useNavigation();
  const [isOpenVerificationModal, setIsOpenVerificationModal] = useState(false);

  const launchVeriff = (veriffurl: string) => {
    (async () => {
      if (Platform.OS === 'web') {
        createFrame({
          url: veriffurl,
          onEvent: function (msg: any) {
            switch (msg) {
              case messages.CANCELED:
                console.log('user canceled the flow before completing');
                break;

              case messages.FINISHED:
                console.log('MESSAGES.FINISHED');
                props.redirectUser();
                break;

              case messages.STARTED:
                console.log('MESSAGES.STARTED');
                break;
            }
          },
          onReload: () => {
            // Logic to re-open Veriff SDK after page reload
            // e.g. sessionStorage.setItem('@veriff-session-url', url);
            window.location.reload();
          }
        });

      } else {
        const result = await VeriffSdk.launchVeriff({sessionUrl: veriffurl});

        switch (result.status) {
          case VeriffSdk.statusDone:
            props.redirectUser();
            break;

          case VeriffSdk.statusCanceled:
            console.log('user canceled the flow before completing');
            break;

          case VeriffSdk.statusError:
            Context.setCancelModalConfig({
              title: 'ERROR', subtitle: `Veriff failed with error=${result.error}`, visible: true, leftBtnText: 'OK',
              onExit: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false}),
              onClose: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
            });
            break;
        }
      }
    })();
  };

  const StartVeriffKycVerification = () => {
    Context.setLoadingOverlay(true);

    ServiceClient.startVeriffKycVerification().then(res => {
      Context.setLoadingOverlay(false);
      if (res) launchVeriff(res);

    }).catch(err => {
      console.log('startVeriffKycVerification err', err);
      Context.setLoadingOverlay(false);

      if (err.message) {
        Context.setCancelModalConfig({
          title: 'ERROR', subtitle: err.message, leftBtnText: 'OK', visible: true,
          onExit: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false}),
          onClose: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
        });
      }
    });
  };

  useLayoutEffect(() => {
    (async () => {
      if (!session) {
        const val = await AsyncStorage.getItem('session');

        if (val) {
          const session = JSON.parse(val);
          Context.setSession(session);

        } else {
          navigation.reset({index: 0, routes: [{name: StartingPage}]});
        }
      }
    })();
  }, []);

  return (
    <Div flex={1} justifyContent="center">
      <P color={colors.lightBlue} fw="600" fs={20} ta="center" mb={62}>Know Your Customer (KYC)</P>

      <Div alignItems="center" px={24}>
        <P maxW={312} ta="center" h={90} mb={28}>
          By selecting the “Proceed” button below, you agree to completing the KYC procedures.
        </P>
      </Div>

      <Div alignItems="center" mb={64}>
        <Button
          text="Proceed with KYC" bg={isFullSwing ? '#3369FF' : undefined} color={isFullSwing ? 'white' : undefined}
          onPress={() => setIsOpenVerificationModal(true)} w={220} mb={16} radius={isFullSwing ? 4 : undefined}
        />

        {!!props.goBack && (
          <Pressable onPress={props.goBack} style={[MainStyle.w_144, MainStyle.h_22]}>
            <P ta="center" color={colors.newDangerText} fw="700" lh={22}>CANCEL</P>
          </Pressable>
        )}
      </Div>

      <VerifyInformationModal
        isOpen={isOpenVerificationModal} onClose={() => setIsOpenVerificationModal(false)}
        onSubmit={StartVeriffKycVerification}
      />
    </Div>
  );
};

export default React.memo(KycTerm);
